import { MutationHookOptions, useMutation } from '@apollo/client'
import {
  MarkAsReadConversationDocument,
  MarkAsReadConversationMutation,
  MarkAsReadConversationMutationVariables,
} from 'generated/resources/graphql'

type Options = MutationHookOptions<
  MarkAsReadConversationMutation,
  MarkAsReadConversationMutationVariables
>

export const useMarkAsReadConversation = (options?: Options) => {
  const [markAsReadConversationMutation, { loading }] = useMutation(
    MarkAsReadConversationDocument,
    options
  )

  return {
    loading,
    markAsReadConversation(variables: MarkAsReadConversationMutationVariables) {
      return markAsReadConversationMutation({
        variables,
      })
    },
  }
}
